// extracted by mini-css-extract-plugin
export default {"current_dialog_list":"MessageBlock_current_dialog_list__3F0Pj"};